import { Directive } from '@angular/core';

/** Marca il contenuto proiettato come prefix (es. help ℹ) nella riga controllo. */
@Directive({
  selector: '[ariaFieldPrefix]',
  standalone: true,
})
export class AriaFieldPrefixDirective {}
